import { green, red, yellow } from '@ant-design/colors';
import { Progress } from 'antd';
import {
    AutomationJobProgress,
    AutomationJobProgressStage
} from '../../Pages/AdminPage/AutomationView/AutomationJobHistoryView/AutomationJobHistoryTableContainer';

function calculateProgress(progress: AutomationJobProgress) {
    const [progressStage, progressValue] = progress.split(':');
    if (progressStage === AutomationJobProgressStage.INITIALIZATION) return (Number(progressValue) / 2).toFixed(0);
    if (progressStage === AutomationJobProgressStage.EXECUTION) return (Number(progressValue) / 2 + 50).toFixed(0);
}

export default function JobProgress({ value }: { value: AutomationJobProgress }) {
    return (
        <Progress
            percent={+calculateProgress(value)}
            status="active"
            steps={5}
            size="small"
            strokeColor={[green[6], green[4], yellow[5], red[3], red[5]]}
        />
    );
}
